import { getTagColor } from "@/utils/tagColors";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export default function TagBadge({ tag, size = "md" }) {
  const sizeClasses = {
    sm: "px-1.5 py-0.5 text-[10px]",
    md: "px-2 py-1 text-xs",
    lg: "px-3 py-1.5 text-sm",
  };

  const color = getTagColor(tag);

  const badge = (
    <span
      data-testid={`tag-badge-${tag.id || tag.name}`}
      className={`${sizeClasses[size]} rounded-sm font-medium border inline-flex items-center`}
      style={{
        backgroundColor: `${color}20`,
        borderColor: `${color}40`,
        color: color,
      }}
    >
      {tag.name}
    </span>
  );

  if (tag.description) {
    return (
      <TooltipProvider delayDuration={200}>
        <Tooltip>
          <TooltipTrigger asChild>{badge}</TooltipTrigger>
          <TooltipContent side="top" className="bg-[#1A1A1A] border-white/10 text-white/80 max-w-xs">
            <p className="text-sm">{tag.description}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return badge;
}
